export default {
  color: 'primary'
}